import React from 'react';
import PropTypes from 'prop-types';
import { FDBodyText, FDEmphasisSurface } from '@facet-wealth/design';

export const Quote = ({ value }) => {
  return (
    <FDEmphasisSurface padding={2}>
      <FDBodyText value={value} />
    </FDEmphasisSurface>
  );
};

Quote.defaultProps = {
  value: undefined,
};

Quote.propTypes = {
  value: PropTypes.string,
};
